module.exports = __webpack_public_path__ + "16513b9860d41c68293e95a3888cb26d.png";